import { render, staticRenderFns } from "./addMenuGroup.vue?vue&type=template&id=cc644d32"
import script from "./addMenuGroup.vue?vue&type=script&lang=js"
export * from "./addMenuGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports